// Ошибки смены статуса осмотра. Бэкенд отвечает {"errors":[{"message","code"}]};
// 409 check_status_final / roadlist_status_final значат, что статус уже сменил кто-то другой.
import { hasApiErrorCode } from './apiError';

export const CHECK_STATUS_FINAL_MESSAGE = 'Статус уже изменён, обновите страницу';

// Принимает ApiError или payload из rejectWithValue ({ status, code })
export function isCheckStatusFinal(error: unknown): boolean {
  return hasApiErrorCode(error, 409, 'check_status_final', 'roadlist_status_final');
}
